export default __webpack_public_path__ + "static/media/7.4f7b6c28.jpg";